import 'js-polyfills/typedarray';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'intersection-observer';
import elementClosest from 'element-closest';

elementClosest(window);
